export enum EndpointsE {
    TOKEN = 'token',
    CLIENTS_GET_USER_INFO = 'api/Clients/GetUserInfo',
    USERS_USER_GET = 'api/Users/UserGet/',
    CLIENTS_GET_LOGO_IMAGE = '/api/Clients/LogoImage/',
}